export function resolveImagePath(rawPath) {
  const trimmed = rawPath.trim();
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('/')) {
    return trimmed;
  }
  return `/${trimmed}`;
}

const FALLBACK_IMAGE_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
  <rect width="128" height="128" rx="8" fill="#e5e7eb" />
  <path d="M32 88l22.9-22.9a10 10 0 0114.14 0L92 88m-10-10l7.93-7.93a10 10 0 0114.14 0L108 74M64 46h.05M36 100h56a10 10 0 0010-10V36a10 10 0 00-10-10H36a10 10 0 00-10 10v54a10 10 0 0010 10z"
        fill="none" stroke="#9ca3af" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`.trim();

export const FALLBACK_IMAGE = `data:image/svg+xml,${encodeURIComponent(FALLBACK_IMAGE_SVG)}`;
